import React from 'react';

const RequestContext = React.createContext({});

export const RequestProvider = RequestContext.Provider;

export default RequestContext;
